import React, {createRef, Fragment, useEffect, useRef, useState} from "react";
import Aux from "../../hoc/hocAux";
import {connect, useSelector} from "react-redux";
import classes from "./ChatBuilder.module.css";

import {
  fetchOnlineDoctors,
  setSelectedItem,
  tabChangeSetSelectedItem,
  findPatientDetail,
  fetchConversations,
  fetchConversationCount,
  fetchDoctorsNameAndImages,
  refreshConversations,
  fetchChatTags,
  childChanged,
  getAcceptStatus,
  checkStatusAccept,
  setFlagTrue,
  setFlagFalse,
  fetchStatus,
  get_followUp,
  set_notification,
  setAlgolia,
  resetConversationListeners, setChatHistoryItemClicked, resetSelectedConversationId
} from "../../actions/ConversationAction";
import { childChangedDoctor, resetAgentListeners } from "../../actions/AgentsAction";
import {
  fetchAllMessages,
  turnSelectChat,
  sendDoctorFirstMessage,
  refreshMessages,
  sendMessage,
  makeUnreadAllMessages,
  imageData,
  fetchUserChatHistory,
  resetChatListeners
} from "../../actions/ChatAction";

import { fetchDoctorDetails, resetDoctorsListeners } from "../../actions/DoctorAction";
import { fetchTags, resetTagsListeners } from "../../actions/TagsAction";
import { fetchCannedResponses, setSubjectiveSymptoms, setAssessment,
  setFindings,
  setPlan, resetCannedResponseListeners} from "../../actions/CannedResponseAction";

// We will use it for Auto-Followup Feature

import ConversationList from "./conversations/ConversationList";
import ChatScreen from "./chats/ChatScreen";
import Modal from "../../components/UI/Modal/Modal";
import ProgressBar from "../../components/UI/Progressbar/Progressbar";

import PatientForm from './patientForm/PatientForm';
import {firebaseRoot} from "../../config";
import {database, functions, remoteConfig} from "../../firebase";
import PatientInfoSection from "./PatientInfoSection/PatientInfoSection";
import PastConsultationSection from "./PastConsultationSection/PastConsultationSection";
import SOAPNotes from "../../components/SOAPNotes/SOAPNotes";
import ImportantLinksSection from "./ImportantLinksSection/ImportantLinksSection";
import HealthCardSection from "./HealthCardSection/HealthCardSection";
import SickNotesSection from "./SickNotesSection/SickNotesSection";
import LabReportsSection from "./LabReportsSection/LabReportsSection";
import PastPrescriptionSection from "./PastPrescriptionSection/PastPrescriptionSection";
import PharmacyComponent from "../../components/pharmacyComponent/pharmacyComponent";
import PrescriptionForm from "../clinicalSide/encounters/patientDetail/prescriptionForm";
import UserWarning from "./UserWarning/UserWarning";
import ParentInfo from "./ParentInfo/ParentInfo";
import moment from "moment";
import axios from "axios";
import AgoraComponent from "./AgoraComponent/AgoraComponent";
import algoliasearch from "algoliasearch";
import _ from 'lodash';
let client_store = algoliasearch("FL1OI9QKUW", "f0427fde3618b1db1bfb004c623215db");
let index_store = client_store.initIndex('conversations');
const Header = (props) => {
  return (
    <div className={classes.cross}>
      <div className={classes.add}>Upload Attachment</div>
    </div>
  );
};
const ChatBuilder = (props) => {
  const [prescriptionDoctors, setPrescriptionDoctors] = useState({})
  const [allowedMedications, setAllowedMedications] = useState([])
  const [selectedConvo, setSelectedConvo] = useState(null)
  //const [selectedClinicInfo, setSelectedClinicInfo] = useState({})
  //const [props.chatHistoryItemClick, setChatHistoryItemClick] = useState(false)
  const [chatHistoryUid, setChatHistoryUid] = useState('')
  const [chatHistoryCategory, setChatHistoryCategory] = useState('')
  const [showUpView, setShowUpView] = useState(false)
  const [skipClassStatus, setSkipClassStatus] = useState(false)
  const [followClassStatus, setFollowClassStatus] = useState(false)
  const [minimizeVideo, setMinimizeVideo] = useState(true)
  const [autoFollowUpEnabled, setAutoFollowUpEnabled] = useState(false)
  const [showUploadingModal, setShowUploadingModal] = useState(false)
  const [showOutPatientForm, setShowOutPatientForm] = useState(false)
  const [dateTime, setDateTime] = useState('')
  const [file, setFile] = useState('')
  const [filetype, setFileType] = useState('')
  const [showOnlineDoctors, setShowOnlineDoctors] = useState(false)
  const [showCannedResponseList, setShowCannedResponseList] = useState(false)
  const [showTagsListModal, setShowTagsListModal] = useState(false)
  const [selectedCannedResponseText, setSelectedCannedResponseText] = useState('')
  const [selectedCannedResponseShortCut, setSelectedCannedResponseShortCut] = useState('')
  const [doctorDetail, setDoctorDetail] = useState([])
  //const [isLoading, setIsLoading] = useState(false)
  //const [messageLength, setMessageLength] = useState(0)
  const [prescriptionCountries, setPrescriptionCountries] = useState([])
  const [prescriptionDoctor, setPrescriptionDoctor] = useState({})
  // ** Referral States
  const [medicalDirectiveNode,setMedicalDirectiveNode] = useState({})
  const [referralArray,setReferralArray] = useState([])
  const doctorID = useSelector((state) => state.doctorReducer.doctorDetail.uid)

/*
  useEffect(() => {
    const addDoctorRole = functions.httpsCallable('addDoctorRole');
    let email = "nadiak_7_9@hotmail.com";
    addDoctorRole({ email}).then(status => {
      console.log('addDoctorRole status.data:', email, ' ' , status.data);
      if (status.data) {
        //console.log('addDoctorRole status.data:', email, ' ' , status.data);
        // callback(true);
        // dispatch({
        // 	type: ADD_AGENT_SUCCESS,
        // 	payload: 'Doctor added successfully'
        // })
      } else {

        // callback(false);
        // dispatch({
        // 	type: ADD_AGENT_FAILS,
        // 	payload: 'Doctor added but addition auth role failed'
        // })
      }
    });
  }, []);
*/

  useEffect(async () => {
    if(doctorID) {
      const {downlink, effectiveType, rtt} = navigator.connection;
      let updates = {}
      updates[`networkLogs/${doctorID}/${Date.now()}`] = {downlink, effectiveType, rtt, timestamp: Date.now()}
      await database.ref().update(updates)
    }

  },[doctorID])

  useEffect(()=>{
    props.getAcceptStatus();
    props.refreshMessages();
    props.refreshConversations();
    props.fetchConversations();
    props.fetchConversationCount();
    props.setAlgolia();
    props.fetchDoctorDetails();
    props.fetchDoctorsNameAndImages();
    //props.fetchOnlineDoctors();
    props.fetchTags();
    props.childChanged();
    props.childChangedDoctor();
    props.fetchCannedResponses();
    props.tabChangeSetSelectedItem("","","","","","","", null);
    fetchGoogleSheetData();
    fetchPrescriptionDoctorsRemoteConfig();

    return(()=>{
      resetConversationListeners();
      resetChatListeners();
      resetAgentListeners();
      resetDoctorsListeners();
      resetTagsListeners();
      resetCannedResponseListeners();
    })
  },[])
  // ** Referral Dropdown Start
  useEffect(()=>{
    database.ref(`medicalDirective`).once("value",snapshot=>{
      const resp = snapshot.toJSON()
      setMedicalDirectiveNode(resp)
    })
  },[])

  useEffect(()=>{
    setReferralArray([])
    if(props.selectedPatient){
      let {country, state} = props.selectedPatient
      country = lowerCaseAndUnderscore(country)
      state = lowerCaseAndUnderscore(state)
      // **
      let referral_object = {}
      let referral_names = []
      if(medicalDirectiveNode?.[country]?.[state]){
        referral_object = medicalDirectiveNode[country][state]
      }else{
        referral_object = medicalDirectiveNode?.[country]?.["general"]
      }
      if(referral_object){
        delete referral_object.family_doctor
        delete referral_object.prescription_noindex
        referral_names = Object.keys(referral_object)
        referral_names = referral_names.map(name=> reverseLowerCaseAndUnderscore(name))
        setReferralArray(referral_names)
      }

    }
  },[props.selectedPatient])
  // ** Referral Dropdown End

  useEffect(()=>{
    if (
        props.deletedConversationKey === props.conversationId ||
        props.changedConversation === props.conversationId
    ) {
      props.refreshMessages();
      //props.resetSelectedConversationId();
    }
  },[props.deletedConversationKey, props.conversationId, props.changedConversation])

  useEffect(()=>{
    if(props.doctorDetail?.length>0 && doctorDetail?.length === 0){
      props.get_followUp("YDO", props.doctorDetail.doctorName);
      setDoctorDetail(props.doctorDetail)
    }
  },[props.doctorDetail.length])

  /*useEffect(()=>{
    if (isLoading === true && props.isLoading === false) {
      //setShowUpView(false)
      setIsLoading(props.isLoading)
    }
  },[props.isLoading])*/

  /*useEffect(()=>{
    props.checkStatusAccept();
  },[props.changedDoctorKey, props.doctorDetail.uid])*/

  /*useEffect(()=>{
    if (props.messages?.length > 0 && messageLength !== props.messages?.length) {
      setMessageLength(props.messages?.length || 0)
    }
  },[props.messages.length])*/

  /*useEffect(()=>{
    let countries = prescriptionDoctors? Object.keys(prescriptionDoctors): []
    setPrescriptionCountries(countries)
    setPrescriptionDoctor(prescriptionDoctors[props.country]? {...prescriptionDoctors[props.country]} : {})
  },[prescriptionDoctors, props.country])*/

  useEffect(()=>{

    /*database.ref(`openconversations`).orderByChild("isDelegate").equalTo(true).once('value', doctorConvosSnap => {
      let doctorConvosJSON = doctorConvosSnap.exists()?doctorConvosSnap.toJSON(): {};

        let convoKeys = Object.keys(doctorConvosJSON);
        let doctorConvos = [];
        let doctorMarshasConvos = [];

        convoKeys.forEach(key=> {
          if(doctorConvosJSON[key].doctorID !== "7Iyxx4jcPqRaOre0KGdHSMhSX4g2") {
            doctorConvos.push( {
              ...doctorConvosJSON[key], id: key
            })
          }else{
            doctorMarshasConvos.push( {
              ...doctorConvosJSON[key], id: key
            })
          }
        })

        console.log("doctorConvos ", doctorConvos)
      console.log("doctorMarshasConvos ", doctorMarshasConvos)

    })*/

/*
    console.log("jsonParsse ", JSON.parse("{\"name\":\"Esther Broussard\",\"patient_birth_date\":\"12/02/1991\",\"patientPhoneNumber\":\"+19023187126\",\"healthCardNumber\":\"\",\"gender\":\"Female\",\"encounterDate\":\"2023-03-01\",\"complaint\":\" Swollen lymph node, sore throat, sore ear, sharp pains in lymph node, feeling like I have a cold for 3 months\",\"findings\":\"https://firebasestorage.googleapis.com/v0/b/yourdoctorsonline-prod/o/conversations%2F-NPSXCfTgOpsaYTo4cK4%2F1677680541703%2FJPEG_1677680474243_?alt=media&token=32b56b98-f15b-4be2-81a6-f531a98ddb51\\nhttps://firebasestorage.googleapis.com/v0/b/yourdoctorsonline-prod/o/conversations%2F-NPSXCfTgOpsaYTo4cK4%2F1677680334646%2FJPEG_1677680287136_?alt=media&token=741e8c12-7cd2-4502-b113-63d5d3cfaff9\\nPatient reported experiencing swollen lymphnodes secondary to developing a cold. Currently, for the past one week patient has sorethroat associated with difficulty swallowing but nasal congestion. Patient didnt report experincing any other symptoms \",\"assessment\":\"Sorethroat and Viral lymphadenopathy\",\"plan\":\"\\nDrug- Benzydamine Gargles\\nQuantity- 1 bottle, 240ml\\nInstructions- Use three times a day for gargles.\\nRefills- 00 \\n\\nMedication: Tablet Acetaminophen 500 mg,\\nComposition: Tablet\\nRoute: Oral\\nDose: 500mg\\nFrequency: Trhice daily for as long as needed\\nQuantity: 15 tablets\\nInstructions: Take one tablet three times a day, as needed. \\nater\\n\\n\\nMedication: Tablet Azithromycin 250 MG\\nComposition: Tablet\\nRoute: Oral\\nDose: 250mg\\nQuantity: Six\\nInstructions: Take two tablets orally on day one and them once daily until finished\\nRefills: none\\n\",\"doctorName\":\"Marsha Dunkley\",\"documentName\":\"Marsha Dunkley-Esther Broussard-2023-03-01--NPSXCfTgOpsaYTo4cK4\",\"signatureImageURL\":\"https://firebasestorage.googleapis.com/v0/b/yourdoctorsonline-prod/o/user_profile%2F7Iyxx4jcPqRaOre0KGdHSMhSX4g2%2Fmarsha_signature.png?alt=media&token=dd8d3500-39ba-4b27-adf1-fe3a8bdbd781\",\"doctorlicense\":\"127668\",\"client_id\":\"177934657566-r98ikj1jh65v15prs3bfb83ijla1f7r2.apps.googleusercontent.com\",\"client_secret\":\"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\",\"refresh_token\":\"1//04RPSsJqaFp0nCgYIARAAGAQSNwF-L9IrFVsqShpGYKzgbFUKZRhe3CY1kRzj1FICqDNuf1FDRq-kDv4S4Fk92fyINclIR4IghTY\",\"folderId\":\"1bmRe7qGb_r1pU2eDcCZbwBOxW90wr7WH\",\"findingAttachments\":\"\"}"))
*/

   /* database.ref(`emrReferralLetters`).once('value', refSnap=>{
      console.log("refSnap count", refSnap.numChildren())
    })*/
/*
    objects.forEach(encounter => {
      setTimeout(()=>{
        console.log("emrEncounters index", index)

        if(encounter.val()){
          let encounterData = encounter.val();
          encounterData.conversation_id = encounter.key;
          console.log("emrEncounters encounterData", encounterData)
          if(!encounterData.emr_saved){
            fetch('https://us-central1-yourdoctorsonline-prod.cloudfunctions.net/storeEMRDataForTier1', {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(encounterData),
            })
                .then(data => {
                  let newConversationRows = conversationRows
                  let newConversation = {
                    conversation_id:encounter.key,
                    data: encounterData
                  }
                  newConversation.status = data.status === 200? "success":"failed"
                  if(data.status === 400) setTotalFailedConversationCount(totalFailedConversationCount)
                  newConversationRows.push(newConversation)
                  setConversationRows([...newConversationRows])
                  console.log("emrEncounters  successful", " ", encounter.key, " ", data)
                  completed++;
                  if(completed === count){
                    setLoading(false)
                  }
                })
                .catch(error => {
                  let newConversationRows = conversationRows
                  let newConversation = {
                    conversation_id:encounter.key,
                    status: "failed",
                    data: encounterData
                  }
                  newConversationRows.push(newConversation)
                  setConversationRows([...newConversationRows])
                  setTotalFailedConversationCount(totalFailedConversationCount)
                  console.log("emrEncounters failed", error)
                  completed++;
                  if(completed === count){
                    setLoading(false)
                  }
                })
          }else{
            completed++;
            if(completed === count){
              setLoading(false)
              alert("completed")

            }
          }
        }else{
          completed++;
          if(completed === count){
            alert("completed")
            setLoading(false)
            alert("completed")

          }
        }
      }, index * 6000)
      index++;

    })
*/


    /* let afterTimeStamp = 1677283200004;
    let afterStartTimeStamp = 1677344511657;
    console.log("moment(afterStartTimeStamp)", moment(afterStartTimeStamp).toDate())
    console.log("moment(afterTimeStamp)", moment(afterTimeStamp).toDate())

    console.log("moment(afterTimeStamp).isAfter(afterStartTimeStamp) ", moment(afterTimeStamp).isAfter(afterStartTimeStamp))
    console.log("moment(afterStartTimeStamp).isAfter(afterTimeStamp) ", moment(afterStartTimeStamp).isAfter(afterTimeStamp)) */

/*
    database.ref(`emrEncounters/-NO6SbyUx4RYDutPKQgx`).once("value" , encounter=> {
      if(encounter.val()){
        let encounterData = {...(encounter.toJSON())};
        if(encounterData.hcardversion){
          encounterData.hcardversion = encounterData.hcardversion.toUpperCase();
        }
        encounterData.conversation_id = encounter.key;
        console.log("emrEncounters encounterData", encounterData)
        if(!encounterData.emr_saved){
          fetch('http://localhost:5001/yourdoctorsonline-prod/us-central1/storeEMRDataForTier1', {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(encounterData),
          })
              .then(data => {

                console.log("emrEncounters encounter saved with data, ", data)
              })
              .catch(error => {

                console.log("emrEncounters failed", error)

              })
        }else{
          console.log("emrEncounters already saved", )
        }
      }else{
        console.log("emrEncounters encounterData not found")
      }
    })
*/


    /* database.ref(`archiveConversations/`).orderByChild('timestamp').startAt(1670160286869).once('value', archivesSnap => {
       console.log("archivesSnap.numChildren", archivesSnap.numChildren())
           archivesSnap.forEach(archiveSnap => {
             console.log("archiveSnap ", archiveSnap.key)
             if (archiveSnap.val()) {
               if (!archiveSnap.val()?.status) {
                 var convos = '';
                 database.ref(`/conversations/${archiveSnap.key}`).once('value', convoSnap => {
                   convoSnap.forEach(convoInstance => {
                     if (convoInstance.val().type === 'text') {
                       convos = convos + " " + convoInstance.val().content;
                     }
                   });
                 }).then(data => {
                   database.ref(`/doctors/${archiveSnap.val().doctorID}`).once('value', doctorSnap => {
                     if (doctorSnap.val()) {
                       database.ref(`/users/${archiveSnap.val().patientID}`).once('value', patientSnap => {
                         if (patientSnap.val()) {
                           let userName = ((patientSnap.val().userName === 'No name' || patientSnap.val().userName === 'Patient') && patientSnap.val().name) ? patientSnap.val().name : patientSnap.val().userName;
                           let archiveData = archiveSnap.toJSON();
                           let tags = "";
                           if (Boolean(archiveData.tagsList)) {
                             var tagslist = _.map(archiveData.tagsList, (val, uid) => {
                               return {...val, uid};
                             });
                             tagslist.forEach(tag => {
                               if (Boolean(tag.name)) {
                                 tags = tags + ', ' + tag.name;
                               }
                             })
                           }
                           let chatCount = patientSnap.val().history_conversations;

                           archiveData.tags = tags;
                           archiveData.objectID = archiveSnap.key;
                           archiveData.conversations = convos;
                           archiveData.category = archiveSnap.val().category;
                           archiveData.doctorID = archiveSnap.val().doctorID;
                           archiveData.patientID = archiveSnap.val().patientID;
                           archiveData.conversationID = archiveSnap.key;
                           archiveData.patientEmail = patientSnap.val().email;
                           archiveData.city = patientSnap.val().city;
                           archiveData.country = patientSnap.val().country;
                           archiveData.platform = patientSnap.val().platform;
                           archiveData.DOB = patientSnap.val().DOB;
                           archiveData.gender = patientSnap.val().gender;
                           archiveData.symptoms = archiveData.followUpData?.diagnosis || patientSnap.val().symptoms;
                           archiveData.medication = patientSnap.val().medication;
                           archiveData.gmtOffset = patientSnap.val().gmtOffset;
                           archiveData.buildNumber = patientSnap.val().buildNumber;
                           archiveData.patientName = userName;
                           archiveData.convoCount = chatCount !== null && chatCount !== undefined ? Object.keys(chatCount).length : 0;
                           archiveData.doctorName = doctorSnap.val().doctorName;
                           archiveData.doctorID = archiveSnap.val().doctorID;
                           archiveData.doctorProfileImg = doctorSnap.val().profileImageURL;
                           archiveData.doctorEmail = doctorSnap.val().email;
                           archiveData.user_id = patientSnap.val().user_id;
                           archiveData.healthInsuranceCardBack = patientSnap.val().healthInsuranceCardBack;
                           archiveData.healthInsuranceCardFront = patientSnap.val().healthInsuranceCardFront;
                           archiveData.healthInsuranceCardNumber = patientSnap.val().healthInsuranceCardNumber;
                           console.log("archiveData ", archiveData)
                           index_store.addObject(archiveData)
                               .then(data => {
                               })
                               .catch(error => {
                                 console.log("error ", error)
                               })
                         }
                       }).then((d) => {
                       }).catch((error) => {
                         console.log("error ", error)
                       })
                     }
                   }).then((d) => {

                   }).catch((error) => {
                     console.log("error ", error)
                   })

                 }).then((d) => {
                 }).catch((error) => {
                   console.log("error ", error)
                 })
               }
             }

           })
         })
     .then((d) => {
     }).catch((error) => {
     })
 */



   /* database.ref(`sessions`).orderByChild('id').equalTo("ruovT8vP8NYNMumYjCnZtJEzZLG3").once('value', sessions =>{
      console.log("sessionsesit ruovT8vP8NYNMumYjCnZtJEzZLG3", sessions.exists())
      if(sessions.exists()){
        console.log("sessions json", JSON.stringify(sessions.toJSON()))
      }
    })*/

/*
    database.ref(`openClinicalConversations/-M_MAx2UTo9V6sFmUrc4`).orderByChild('queued').equalTo(true).once('value', openConvos =>{
      console.log("openClinicalConversations exist", openConvos.exists())
      console.log("openClinicalConversations count", openConvos.numChildren())

      let oldDate = moment().subtract(6, 'hours');
      if(openConvos.exists()){
        openConvos.forEach(convo => {
          let chatDate = moment(convo.val().timestamp);
          console.log("chatDate ", chatDate.toString())
          console.log("oldDate ", oldDate.toString())
          if(chatDate.isSameOrAfter(oldDate)){
            console.log("openClinicalConversations its today")
            let payload = {
                      "clinic_id": "-M_MAx2UTo9V6sFmUrc4",
                      "conversation_id": convo.key
                    }
                    axios({
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                      },
                      url: `${firebaseRoot}/checkShiftToYDO`,
                      mode: 'cors',
                      data: payload,
                    }).then((data) => {
                      console.log("openClinicalConversations checkShiftToYDO success", convo.key)

                    }).catch(error=> {
                      console.log("openClinicalConversations checkShiftToYDO error ", convo.key, payload)
                    })
          }else{
            console.log("openClinicalConversations is old")
            let patientID = convo.val().patientID
            console.log("openClinicalConversations patientID ", patientID)

            if(patientID){
              let updates = {};
              updates[`users/${patientID}/conversations`] = null;
              updates[`openClinicalConversations/-M_MAx2UTo9V6sFmUrc4/${convo.key}`] = null;
              updates[`conversations/${convo.key}`] = null;
              console.log("openClinicalConversations updates ", updates)

              database.ref().update(updates).then((main) => {
                    console.log('openClinicalConversations main ', main);
                    database.ref(`users/${patientID}`).once('value', userSnap => {
                      if(userSnap.exists()){
                        let patientNumber = userSnap.val().phone_number;
                        if(patientNumber){
                          console.log("openClinicalConversations patientNumber ", patientNumber)
                          let payload = {
                            "phoneNumberTo": patientNumber,
                            "messageText": "You recently tried to connect with one of the doctors, however, due to a technical glitch, we couldn’t connect with you.\n" +
                                "We sincerely apologize for the inconvenience. Our development team has fixed our issue, so if you need to connect with a doctor, we are standing by to help you.\n" +
                                "Sincerely,\n - Your Doctors Online Team"
                          }
                          console.log("openClinicalConversations is old")
                          axios({
                            method: 'POST',
                            headers: {
                              'Content-Type': 'application/json',
                            },
                            url: `${firebaseRoot}/sendTextMessage`,
                            mode: 'cors',
                            data: JSON.stringify(payload),
                          }).then((data) => {

                          }).catch(error=> {
                            console.log("openClinicalConversations sendTextMessage ", convo.key)

                          })
                        }
                      }
                    })

                  })
                  .catch((error) => {
                    console.log('openClinicalConversations error ',updates, error);
                  });

            }

          }
        })
        //console.log("sessions json ", JSON.stringify(sessions.toJSON()))
      }
    })
*/

/*
      database.ref('users').orderByChild('phone_number').equalTo("+17096856587").once('value', usersSnap =>{
      console.log("sessionsesit users exists", usersSnap.exists())
        let users = usersSnap.toJSON();
        let usersWithSources = {};
        let sources = {};
        Object.keys(users).forEach(uid => {
          if(users[uid].sources){
            let source = Object.keys(users[uid].sources);
            //let sourceTimeStamps = Object.keys(users[uid].sources);

            usersWithSources[uid] = {sources : source.join(',')}
            //usersWithSources.push({key:uid, sources:users[uid].sources, email:users[uid].email, history_conversations:users[uid].history_conversations || null })
          }
        })

        console.log("sessionsesit usersWithSources json count", Object.keys(usersWithSources).length)
        console.log("sessionsesit usersWithSources json", users)

        //console.log("sessionsesit users count", Object.keys(users))

        //console.log("sessionsesit users json", JSON.stringify(users))

    })
*/

   /* axios.get("https://northamerica-northeast1-yourdoctorsonline-staging.cloudfunctions.net/searchCanadianPharmacies?lat=43.08913583818792&lng=-79.12339957541768")
        .then(data => console.log("searchCanadianPharmacies", {data}))
        .catch(error => console.log("searchCanadianPharmacies", {error}))
*/

    /*database.ref(`openClinicalConversations/-M_MAx2UTo9V6sFmUrc4`).orderByChild('queued').equalTo(true).once('value', sessions =>{
      console.log("sessionsesit emrEncounters", sessions.exists())
      if(sessions.exists()){
        console.log("sessions json", JSON.stringify(sessions.toJSON()))
      }
    })*/

   /* database.ref('users').orderByChild('phone_number').endAt("4166291345").once('value', users =>{
      console.log("sessionsesit users exists", users.exists())
      console.log("sessionsesit users json", JSON.stringify(users.toJSON()))

    })*/

    /*database.ref('doctors').orderByChild('jobTitle').equalTo("Please update title").once('value', users =>{
      console.log("sessionsesit users exists", users.exists())
      console.log("sessionsesit users json", JSON.stringify(users.toJSON()))
    })*/
    /*

    console.log("banDevices key ", database.ref(`/banDevices`).push().key)*/

   /* database.ref(`/banDevices`).once("value", function (bannedUsers) {
      var banned = bannedUsers.val();
      console.log("banned fetched ", JSON.stringify(bannedUsers.toJSON()))
      if (banned) {
        for (var user in banned) {
          if (banned[user].deviceID === "A2E631E2-75BF-4442-B20D-A33A29239FAB") {
            console.log("banned user ", user)
            console.log("banned[user] ", banned[user])
          }
        }
      }
    }) */
    /*database.ref(`emrEncounters`).orderByChild('specialityCode').limitToFirst(1).once('value', sessions =>{
      console.log("sessionsesit emrEncounters", sessions.exists())
      if(sessions.exists()){
        console.log("sessions json", JSON.stringify(sessions.toJSON()))
      }
    })*/
    /*database.ref(`ratings`).orderByChild('rating').equalTo("1").once('value', sessions =>{
      console.log("sessionsesit ratings ", sessions.exists())
      if(sessions.exists()){
        console.log("sessions json", Object.keys(sessions.toJSON()).toString())
      }
    })*/

    /*database.ref(`sessions`).orderByChild('id').equalTo("vliN3PM1MBU9dn1rTg3mNk18Sj63").once('value', sessions =>{
          console.log("sessionsesit vliN3PM1MBU9dn1rTg3mNk18Sj63", sessions.exists())
          if(sessions.exists()){
            console.log("sessions json", JSON.stringify(sessions.toJSON()))
          }
        })*/
    /*console.log('sessions about to render')
    database.ref(`sessions`).orderByChild('pharmacy').equalTo("NYprescription").once('value', sessionsSnap =>{
          console.log("sessionsesit NYprescription", sessionsSnap.exists())
          if(sessionsSnap.exists()){
            let sessionsJSON = sessionsSnap.toJSON();
            // let sessions = Object.values(sessionsJSON);
            // let updatedSessions = sessions.filter(session=>session.timestamp>1663441200000);

            //
            console.log("sessions json", JSON.stringify(sessionsJSON))
          }
        }).then(()=>{
      console.log('sessions then')
    }).catch((e)=>{
      console.log('sessions error', e)
    })*/
    /*console.log("yaar chal jaa")
    database.ref(`archiveConversations`).orderByChild('start_timestamp').startAt(1673618400000).endAt(1673704800000).once('value', archives =>{
      console.log("sessionsesit HZrJ2oe48ZR3WYDpdHanPzXNzJF2", archives.exists())
      if(archives.exists()) {

        let count = archives.numChildren();
        console.log("all chats", count)
        let index = 0;
        let canadianCount = 0;
        archives.forEach(archive => {
          if(archive.val()?.isEMRChat)console.log("isEMRChat")
        })
      }
    }).then(data=>{
      console.log("yaar chal jaa success")
    }).catch(e=>{
      console.log("yaar chal jaa error", e)
    })*/
/*
    database.ref(`archiveConversations`).orderByChild('start_timestamp').startAt(1664701200000).endAt(1664787600000).once('value', archives =>{
      console.log("sessionsesit HZrJ2oe48ZR3WYDpdHanPzXNzJF2", archives.exists())
      if(archives.exists()){
        let count = archives.numChildren();
        let index = 0;
        let canadianCount = 0;
        archives.forEach(archive => {

          if(archive.val().patientID){
             database.ref(`users/${archive.val().patientID}/country`).once('value', countrySnap => {
                index++;
               if(countrySnap.val() === "Canada"){
                 canadianCount++;
                 console.log("canadianCount");
               }
               if(index === count){
               console.log("canadianCountEnded ", canadianCount);
               }
             })
          }else{
            index++;
          }

        })
        //console.log("sessions json", JSON.stringify(archives.toJSON()))

      }
    })
*/
    /* database.ref(`sessions`).orderByChild('id').equalTo("n6UPeBfModRmwPctzqm1GJUP8ot1").once('value', sessions =>{
      console.log("sessionsesit n6UPeBfModRmwPctzqm1GJUP8ot1", sessions.exists())
      if(sessions.exists()){
        console.log("sessions json", JSON.stringify(sessions.toJSON()))
      }
    }) */
    /* database.ref(`sessions`).orderByChild('id').equalTo("dtIrJdZys1QCD2Puc8tNw9lUsAp2").once('value', sessions =>{
     console.log("sessionsesit dtIrJdZys1QCD2Puc8tNw9lUsAp2", sessions.exists())
     if(sessions.exists()){
       console.log("sessions json", JSON.stringify(sessions.toJSON()))
     }
   }) */
/*
      database.ref(`/tier2SoapNotes/`).orderByChild('saved').equalTo(null).once('value', tier2Snap => {
        if(tier2Snap.exists()){
          console.log("tier2Snap.numchildern ", tier2Snap.numChildren())
          tier2Snap.forEach((soapnote) => {
              //console.log("soapnote ", soapnote.val())
            console.log("soapnote.key ", soapnote.key)
            database.ref(`/archiveConversations/${soapnote.key}`).once('value', archiveData => {
              console.log("archiveData.val ", archiveData.val())
                if(archiveData.exists()){
                  const assessment = archiveData.val().assessment;
                  const diagnosisValue = archiveData.val().diagnosisValue;
                  const plan = archiveData.val().plan;
                  const prescriptionspdf = archiveData.val().prescriptionspdf;
                  const soapnotespdf = archiveData.val().soapnotespdf;
                  const symptoms = archiveData.val().symptoms;
                  const findings = archiveData.val().findings;
                  console.log("soapnote ", soapnote.val());
                  console.log("archive ", {assessment, diagnosisValue, plan, prescriptionspdf, soapnotespdf, symptoms, findings});

                  let updates = {};
                  if(soapnote.val().assessment && !assessment){
                    updates[`/archiveConversations/${soapnote.key}/assessment`] = soapnote.val().assessment?soapnote.val().assessment.replace(/["]+/g, ' '):soapnote.val().assessment;
                  }
                  if(soapnote.val().diagnosisValue && !diagnosisValue){
                    updates[`/archiveConversations/${soapnote.key}/diagnosisValue`] = soapnote.val().diagnosisValue?soapnote.val().diagnosisValue.replace(/["]+/g, ' '):soapnote.val().diagnosisValue;
                  }
                  if(soapnote.val().plan && !plan){
                    updates[`/archiveConversations/${soapnote.key}/plan`] = soapnote.val().plan?soapnote.val().plan.replace(/["]+/g, ' '):soapnote.val().plan;
                  }
                  if(soapnote.val().prescriptionspdf && !prescriptionspdf){
                    updates[`/archiveConversations/${soapnote.key}/prescriptionspdf`] = soapnote.val().prescriptionspdf;
                  }
                  if(soapnote.val().soapnotespdf && !soapnotespdf){
                    updates[`/archiveConversations/${soapnote.key}/soapnotespdf`] = soapnote.val().soapnotespdf;
                  }
                  if(soapnote.val().symptoms && !symptoms && symptoms !== soapnote.val().symptoms ){
                    updates[`/archiveConversations/${soapnote.key}/symptoms`] = soapnote.val().symptoms?soapnote.val().symptoms.replace(/["]+/g, ' '):soapnote.val().symptoms;
                  }
                  if(soapnote.val().findings && !findings){
                    updates[`/archiveConversations/${soapnote.key}/findings`] = soapnote.val().findings?soapnote.val().findings.replace(/["]+/g, ' '):soapnote.val().findings;
                  }
                  console.log("updates ", updates)
                  console.log("Object.keys(updates) ", Object.keys(updates))

                  if(Object.keys(updates).length>0){
                    database.ref().update(updates).then(()=>{
                      console.log("`/tier2SoapNotes/${soapnote.key}/saved` ", `/tier2SoapNotes/${soapnote.key}/saved`)
                      database.ref(`/tier2SoapNotes/${soapnote.key}/saved`).set(true);
                    }).catch((e)=>{})
                  }else{
                    database.ref(`/tier2SoapNotes/${soapnote.key}/saved`).set(true);
                  }

                }
            })

          })
        }
      })
*/
  },[])

  const lowerCaseAndUnderscore = (string)=>{
    if(string){
      return string.toLowerCase().replace(/\s/g, "_");
    }
    return ""
  }

  const reverseLowerCaseAndUnderscore = (string)=>{
    if(string){
      return string.split("_").map(function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }).join(" ");
    }
    return ""
    }

  const fetchGoogleSheetData = () => {
    /*fetch(firebaseRoot + '/getGoogleSheetsData')
        .then(res => res.json())
        .then(data => {
          setAllowedMedications(data)
        }).catch(error => {
      //console.log("getGoogleSheetsData ", error)
    })*/
  }

  const fetchPrescriptionDoctorsRemoteConfig = () => {
    /*remoteConfig
        .fetch(0)
        .then(() => remoteConfig.fetchAndActivate())
        .then(() => remoteConfig.getAll())
        //.then(arr => remoteConfig.getValues(arr))
        .then((objects) => {
          let data = {};

          // Retrieve values
          Object.entries(objects).forEach(($) => {
            const [key, entry] = $;
            data[key] = entry.asString();

            if (key === "prescription_doctors_detail") {
              setPrescriptionDoctors(JSON.parse(data[key]))
            }
          });
        })
        .catch((error) => {
          //console.log(`error processing config header screen: ${error}`)
        });*/
  };

  const TopBar = () => {
    return(<div className={classes.top_bar}>
      <div className={classes.header_doctor_name}>
        <span>{props.doctorDetail.doctorName}</span>
      </div>
      <div className={classes.header_status}>
        Status:
        {props.acceptingChat && <span> Accepting Patients</span>}
        {!props.acceptingChat && (
            <span className={classes.notAcceptingChat}>
                  {" "}
              Not Accepting Patients
                </span>
        )}
      </div>
    </div>)
  }

  const searchFirebaseId = (id, followUp_id, index) => {
    props.set_notification(id, followUp_id, index);
    props.get_followUp("YDO", props.doctorDetail.doctorName);
  };

  const showMessages = async ( paidChat, conversationId, patientID, doctorID, issue, category, start_time ) => {
    //setSelectedClinicInfo({})
    /*props.setFlagFalse();
    await props.setFlagTrue();*/
    //setShowUpView(false)
    //setSkipClassStatus(false)
    //setFollowClassStatus(false)
    //setMinimizeVideo(false)

  };

  const closeChat = () => {
    let medicationObject = props.user_medications && props.user_medications[props.conversationId]
    let medications = medicationObject?.data || []
    let check = medicationObject?.isChanged || false

    if(check === true){
      alert("Please either save your changes in prescription or discard them.");
      return;
    }
    if (
        medications?.length > 0 &&
        !props?.selectedPatient?.pharmacy?.fax_number
    ) {
      alert("Please enter fax number for sending out the prescription.");
      return;
    }

    if (window.confirm("Are you sure you want to close this chat?")) {
      if (props.doctorIsValid || props.admin) {
        setShowOutPatientForm(true)
        setShowUpView(false)
      }
    }

  };

  const onChatHistoryItemClick = (historyIndex, category, issue) => {
    props.setChatHistoryItemClicked(historyIndex)
    setChatHistoryCategory(issue)
  };

  const loadCurrentChat = () => {
    props.fetchAllMessages(
        props.conversationId,
        props.chatHistoryItemClick
    );
    props.setChatHistoryItemClicked(null)
  };

  const onHideAddAgentModal = () => {
    setShowUploadingModal(false)
  };

  const closeChatModal = () => {
    setShowOutPatientForm(false)
  };

  const uploadImage = () => {
    if (file !== "") {
      props.imageData(file, function (image_url) {
        if (image_url !== null) {
          props.sendMessage(
              props.conversationId,
              { type: filetype, content: image_url },
              props.patientId,
              props.doctorName,
              props.doctorImage
          );
          setShowUploadingModal(false)
        }
        setShowUploadingModal(false)
      });
    }
  };

  const transferChat = () => {
    setShowOnlineDoctors(!showOnlineDoctors)
  };

  const onAssignClick = () => {
    setShowOnlineDoctors(!showOnlineDoctors)

  };



  const _handleImageChange = (e) => {
    e.preventDefault();

    let reader = new FileReader();
    let newFile = e.target.files[0];

    reader.onloadend = () => {
      let fileType = newFile.type.split("/");
      setFile(newFile)
      setFileType(fileType[0])
      setShowUploadingModal(true)
    };
    reader.readAsDataURL(newFile);
  };
  console.log("ChatBuilder rendered")
  return(
      <Fragment>
        <Aux>
          <TopBar />
          <div className={classes.main}>
            <ConversationList
                searchFirebaseId={searchFirebaseId}
                showMessages={showMessages}
            />

            <ChatScreen
                //sendDoctorFirstMessage={props.sendDoctorFirstMessage}
                closeChat={closeChat}
                //videoState={videoState}
                videoChat={() => {
                  //startVideoChat()
                }}
                maximizeVideo={() => {
                  //maximizeVideo()
                }}
                transferChat={transferChat}
                onAssignClick={onAssignClick}
                showOnlineDoctors={showOnlineDoctors}
                //open={showTagsListModal}
                //showCannedResponseList={showCannedResponseList}
                //selectedCannedResponseText={
                //  selectedCannedResponseText
                //}
                //selectedCannedResponseShortCut={
                //  selectedCannedResponseShortCut
                //}
                //onCannedResponseClick={onCannedResponseClick}
                //onCannedResponseShow={onCannedResponseShow}
                //selectedCannedResponse={selectedCannedResponse}
                //openTagListModal={openTagListModal}
                //onRemoveTagClick={onRemoveTagClick}
                inputElement={createRef()}
                textareaElement={createRef()}
                //onAttachmentClick={onAttachmentClick}
                _handleImageChange={_handleImageChange}
                //autoFollowUpEnabled={Boolean(autoFollowUpEnabled)}
            />
            <div className={classes.mainUserDetail}>
              <div className={classes.container}>
                <div className={classes.content_container}>
                  <div className={classes.main_content_container}>
                    <div className={classes.detailed_view}>
                      <div className={classes.detailed_view_container}>
                         <AgoraComponent doctorID={props.doctorDetail?.uid}/>

                        {!!props.conversationId && <UserWarning />}
                        {!!props.conversationId &&
                        <Fragment>
                          {!!props.conversationId && (props.profile_data?.role === 'Admin' ||  props.doctorIsValid) && <ParentInfo />}
                        </Fragment>}
                        {!!props.conversationId &&
                        <Fragment>
                          {!!props.conversationId && (props.profile_data?.role === 'Admin' ||  props.doctorIsValid) && <PatientInfoSection />}
                        </Fragment>}
                        {!!props.conversationId && (props.profile_data.role === 'Admin' ||  props.doctorIsValid) &&
                        <PastConsultationSection
                            historyMessage={onChatHistoryItemClick}
                            loadCurrentChat={loadCurrentChat}

                        />}


                        {/* Soap Notes Tab - Starts Here */}

                        {/*{!!props.conversationId && (props.profile_data.role === 'Admin' ||  props.doctorIsValid) && <SOAPNotes />}*/}

                        {/* Soap Notes Tab - Ends Here */}
                        {!!props.conversationId && (props.profile_data.role === 'Admin' ||  props.doctorIsValid) && <ImportantLinksSection />}

                        {!!props.conversationId && (props.profile_data.role === 'Admin' ||  props.doctorIsValid) && <HealthCardSection />}


                        {!!props.conversationId && (props.profile_data.role === 'Admin' ||  props.doctorIsValid) && <SickNotesSection />}

                        {!!props.conversationId && (props.profile_data.role === 'Admin' ||  props.doctorIsValid) && <LabReportsSection />}
                        {!!props.conversationId && (props.profile_data.role === 'Admin' ||  props.doctorIsValid) && <PastPrescriptionSection />}


                        {!!props.conversationId /*&& prescriptionCountries && prescriptionCountries.indexOf(props.country) > -1 */ && (props.profile_data.role === 'Admin' ||  props.doctorIsValid) && <PharmacyComponent pharmacy={props?.selectedPatient?.pharmacy} patientFirebaseID={props.patientId}/>}

                        {false && !!props.conversationId /*&& prescriptionCountries && prescriptionCountries.indexOf(props.country) > -1*/ && (props.profile_data.role === 'Admin' ||  props.doctorIsValid) && <PrescriptionForm {...props} isFrom="tier1" sendYDOMessage={props.sendMessage} /*prescriptionDoctor={prescriptionDoctor}*/></PrescriptionForm>}

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*<UserDetailedScreen
                ref={userDetail}
                historyMessage={onChatHistoryItemClick}
                loadCurrentChat={loadCurrentChat}
                prescriptionDoctors={prescriptionDoctors}
            />*/}
            <Modal
                show={showUploadingModal}
                modalClosed={onHideAddAgentModal}
            >
              <div className={classes.modal}>
                <Header />
                {props.uploadingImage && <ProgressBar />}
                {!props.uploadingImage && (
                    <div className={classes.modalcontainer}>
                    <span className={classes.spandiv}>
                      {file.name}
                    </span>
                      <button
                          className={classes.btn}
                          type="button"
                          onClick={uploadImage}
                      >
                        Upload
                      </button>
                    </div>
                )}
              </div>
            </Modal>
            <PatientForm
                show={showOutPatientForm}
                hideModal={closeChatModal}
                referralArray = {referralArray}
                //followClassStatus={followClassStatus}
                autoFollowUpEnabled={Boolean(autoFollowUpEnabled)}
                // prescriptionDoctors={prescriptionDoctors}

            />
          </div>

        </Aux>
      </Fragment>

  )

}

const mapStateToProps = ({
  conversationReducer,
  chatReducer,
  doctorReducer,
  acceptingReducer,
  profileReducer
}) => {
  const {profile_data} = profileReducer;
  const {
    deletedConversationKey,
    patientId,
    doctorIsValid,
    conversationId,
    admin,
    changedConversation,
    user_medications,
    chatHistoryItemClick,
    selectedPatient
  } = conversationReducer;

  const { acceptingChat, changedDoctorKey } = acceptingReducer;
  const {
    doctorName,
    doctorImage,
    uploadingImage
  } = chatReducer;

  const { doctorDetail } = doctorReducer;
/*
  const { isLoading } = tagsReducer;
*/

  /*if (conversations.length !== 0) {
    conversations.sort(function (a, b) {
      return a.timestamp > b.timestamp ? -1 : b.timestamp > a.timestamp ? 1 : 0;
    });
  }*/

  // if (messages.length !== 0) {
  //     messages.sort(function (a, b) { return (a.receiveMessage.timestamp < b.receiveMessage.timestamp) ? -1 : ((b.receiveMessage.timestamp > a.receiveMessage.timestamp) ? 1 : 0); });
  //

  return {
    deletedConversationKey,
    acceptingChat,
    changedDoctorKey,
    changedConversation,
    doctorName,
    doctorImage,
    uploadingImage,
    patientId,
    doctorIsValid,
    conversationId,
    doctorDetail,
    admin,
    user_medications,
    profile_data,
    chatHistoryItemClick,
    selectedPatient
  };
};

export default connect(mapStateToProps, {
  fetchOnlineDoctors,
  getAcceptStatus,
  fetchDoctorDetails,
  fetchUserChatHistory,
  fetchTags,
  fetchCannedResponses,
  checkStatusAccept,
  fetchConversations,
  fetchConversationCount,
  fetchDoctorsNameAndImages,
  childChanged,
  childChangedDoctor,
  refreshConversations,
  refreshMessages,
  setSelectedItem,
  tabChangeSetSelectedItem,
  findPatientDetail,
  fetchAllMessages,
  turnSelectChat,
  sendDoctorFirstMessage,
  sendMessage,
  set_notification,
  makeUnreadAllMessages,
  imageData,
  fetchChatTags,
  setFlagTrue,
  setFlagFalse,
  fetchStatus,
  get_followUp,
  setAlgolia,
  setSubjectiveSymptoms,
  setAssessment,
  setFindings,
  setPlan,
  resetConversationListeners,
  resetChatListeners,
  resetAgentListeners,
  resetDoctorsListeners,
  resetTagsListeners,
  resetCannedResponseListeners,
  setChatHistoryItemClicked,
  resetSelectedConversationId
})(ChatBuilder);
